module.exports = __webpack_public_path__ + "static/media/Decisions_Step2_Image18b.2cf19413.webp";